module.exports = __webpack_public_path__ + "img/chart_notes.5b0b5c48.png";